import {Component, Input, OnInit} from '@angular/core';
import {TranslatedNames} from "../../../models/turns-models/translated-names.model";
import {FormControl, FormGroup} from "@angular/forms";
import {SnackBarService} from "../../shared-components/snack-bar/snack-bar.service";
import {DesksTurnsService} from "../../../services/turns-services/desks-turns-service/desks-turns.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-turns-desk-translation',
  templateUrl: './turns-desk-translation.component.html',
  styleUrls: ['./turns-desk-translation.component.scss']
})
export class TurnsDeskTranslationComponent implements OnInit {

  @Input() translation: TranslatedNames
  basicDataForm: FormGroup
  updateDeskTranslationSubscription: Subscription;

  constructor(
    private desksTurnsService: DesksTurnsService,
    private snackbarService: SnackBarService
  ) {
    this.basicDataForm = new FormGroup({
      translatedValue: new FormControl({ value: null })
    });
  }

  ngOnInit() {
  }

  ngOnChanges() {
    if(this.translation) {
      this.resetForm();
    }
  }

  public inputChange() {
    if (this.basicDataForm.get('translatedValue').dirty) {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
        this.resetForm();
      }
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('translatedValue').value) {
      return 'turns-page.snackbar messages.initial translatedValue required error';
    } else {
      return true;
    }
  }

  public submitForm() {
    this.translation.translatedValue = this.basicDataForm.get('translatedValue').value
    const translatedNames: TranslatedNames[] = [this.translation]
    this.updateDeskTranslationSubscription = this.desksTurnsService.updateDeskDeskNameTranslation(translatedNames).subscribe(
      (res) => {
        this.snackbarService.open('turns-page.snackbar messages.update translatedValue success', 'success');
        this.desksTurnsService.refreshDesk();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      translatedValue: this.translation.translatedValue
    });
  }

  ngOnDestroy() {
    if (this.updateDeskTranslationSubscription) { this.updateDeskTranslationSubscription.unsubscribe(); }
  }

}
